<template>
    <div id="error" class="flex">
        网上开庭平台
    </div>
</template>

<script>
  export default {
    name: 'error'
  };
</script>

<style scoped lang="scss">
#error{
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 30px;
}
</style>
